import { FlagIcon, MoreHorizontalFillIcon } from '@chegg-ui/horizon-icons'
import { Typography } from '@chegg-ui/typography'
import { IconButton, IconButtonProps } from '@chegg-ui/button'

import { forwardRef } from 'react'
import { PopoverPosition } from '@chegg-ui/popover'
import {
  PopoverContainer,
  PopoverContainerListItem,
  PopoverItemButton,
  PopoverWrapper,
} from './styled'

type MoreButtonProps = Omit<IconButtonProps, 'screenReaderOnlyText' | 'children'> & {}

type ThreeDotsProps = MoreButtonProps & {
  onFlagClick: () => void
  position?: string
}

const POPOVER_WIDTH = '72px'

const MoreButton = forwardRef((
  props: MoreButtonProps, // props are needed as popover passes additional props
  ref
) => (
  <IconButton screenReaderOnlyText="more button" size="small" {...props} ref={ref as any}>
    <MoreHorizontalFillIcon />
  </IconButton>
))

export const ThreeDots = ({ onFlagClick, position, ...iconBtnProps }: ThreeDotsProps) => (
  <PopoverWrapper
    targetElement={<MoreButton {...iconBtnProps} />}
    position={position as PopoverPosition}
    width={POPOVER_WIDTH}
  >
    <PopoverContainer>
      <PopoverContainerListItem>
        <PopoverItemButton onClick={onFlagClick}>
          <FlagIcon />
          <Typography variant="body2" variantType="bold">
            Flag
          </Typography>
        </PopoverItemButton>
      </PopoverContainerListItem>
    </PopoverContainer>
  </PopoverWrapper>
)
